export enum ProviderSwitchType {
  None = 0,
  Star
}
